import { motion } from 'framer-motion';

const FloralDecorations = () => {
  return (
    <>
      {/* Top Right - Autumn elegant branches - LARGER */}
      <motion.div
        className="fixed top-0 right-0 w-52 md:w-80 h-52 md:h-80 pointer-events-none z-10"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.5, delay: 0.3 }}
      >
        <svg viewBox="0 0 200 200" className="w-full h-full" fill="none">
          {/* Elegant curved branches */}
          <path 
            d="M200 0 C170 25, 165 60, 175 95 C168 115, 150 108, 135 125" 
            stroke="#5D4037" 
            strokeWidth="1.2" 
            opacity="0.35"
            strokeLinecap="round"
          />
          <path 
            d="M185 10 C160 35, 145 30, 120 50" 
            stroke="#8D6E63" 
            strokeWidth="0.8" 
            opacity="0.25"
          />
          
          {/* Autumn leaves - varied shapes */}
          <path d="M170 85 Q175 70, 185 75 Q180 85, 170 85" fill="#CCA598" opacity="0.4" />
          <path d="M150 55 Q158 42, 168 50 Q160 58, 150 55" fill="#8D6E63" opacity="0.3" />
          <path d="M130 70 Q140 60, 148 68 Q138 76, 130 70" fill="#D7CCC8" opacity="0.35" />
          <path d="M145 100 Q155 88, 162 98 Q152 106, 145 100" fill="#CCA598" opacity="0.3" />
          
          {/* Small berries cluster */}
          <circle cx="188" cy="25" r="3" fill="#5D4037" opacity="0.4" />
          <circle cx="180" cy="35" r="2.5" fill="#8D6E63" opacity="0.35" />
          <circle cx="192" cy="38" r="2" fill="#CCA598" opacity="0.3" />
          
          {/* Delicate seed pods */}
          <ellipse cx="160" cy="40" rx="2" ry="5" transform="rotate(-30 160 40)" fill="#8D6E63" opacity="0.25" />
          <ellipse cx="175" cy="60" rx="2" ry="4" transform="rotate(-45 175 60)" fill="#CCA598" opacity="0.2" />
        </svg>
      </motion.div>

      {/* Top Left - Autumn accent - LARGER */}
      <motion.div
        className="fixed top-0 left-0 w-44 md:w-64 h-44 md:h-64 pointer-events-none z-10"
        initial={{ opacity: 0, x: -25 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.4, delay: 0.5 }}
      >
        <svg viewBox="0 0 150 150" className="w-full h-full" fill="none">
          <path 
            d="M0 0 C30 20, 40 55, 25 90" 
            stroke="#CCA598" 
            strokeWidth="1" 
            opacity="0.3"
            strokeLinecap="round"
          />
          
          {/* Autumn leaves */}
          <path d="M30 70 Q25 55, 38 60 Q35 72, 30 70" fill="#D7CCC8" opacity="0.35" />
          <path d="M45 45 Q38 35, 52 38 Q48 50, 45 45" fill="#CCA598" opacity="0.28" />
          
          {/* Small berries */}
          <circle cx="15" cy="25" r="2.5" fill="#8D6E63" opacity="0.3" />
          <circle cx="25" cy="38" r="2" fill="#CCA598" opacity="0.25" />
        </svg>
      </motion.div>

      {/* Bottom Left - Main autumn arrangement - LARGER */}
      <motion.div
        className="fixed bottom-0 left-0 w-64 md:w-96 h-64 md:h-96 pointer-events-none z-10"
        initial={{ opacity: 0, x: -35 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.5, delay: 0.4 }}
      >
        <svg viewBox="0 0 250 250" className="w-full h-full" fill="none">
          {/* Main branches */}
          <path 
            d="M0 250 C35 210, 30 170, 50 130 C60 100, 85 115, 95 85" 
            stroke="#5D4037" 
            strokeWidth="1.3" 
            opacity="0.35"
            strokeLinecap="round"
          />
          <path 
            d="M0 210 C45 185, 70 195, 100 165" 
            stroke="#8D6E63" 
            strokeWidth="0.9" 
            opacity="0.28"
            strokeLinecap="round"
          />
          <path 
            d="M30 250 C50 215, 40 180, 60 150" 
            stroke="#CCA598" 
            strokeWidth="0.7" 
            opacity="0.25"
          />
          
          {/* Autumn leaves - oak and maple inspired */}
          <path d="M45 140 Q38 120, 58 125 Q55 142, 45 140" fill="#CCA598" opacity="0.4" />
          <path d="M70 160 Q60 145, 82 148 Q78 165, 70 160" fill="#8D6E63" opacity="0.32" />
          <path d="M55 175 Q48 160, 68 165 Q62 180, 55 175" fill="#D7CCC8" opacity="0.35" />
          <path d="M85 130 Q78 115, 95 120 Q90 135, 85 130" fill="#CCA598" opacity="0.3" />
          <path d="M95 155 Q88 142, 105 148 Q100 160, 95 155" fill="#8D6E63" opacity="0.28" />
          
          {/* Small olive touches */}
          <path d="M60 120 Q55 110, 68 112 Q65 122, 60 120" fill="#8F9779" opacity="0.15" />
          
          {/* Berry clusters - autumn rosehips */}
          <g opacity="0.45">
            <circle cx="25" cy="220" r="4" fill="#5D4037" />
            <circle cx="38" cy="208" r="3.5" fill="#8D6E63" />
            <circle cx="30" cy="195" r="3" fill="#CCA598" />
            <circle cx="48" cy="218" r="3" fill="#8D6E63" />
          </g>
          
          <g opacity="0.35">
            <circle cx="80" cy="185" r="3" fill="#CCA598" />
            <circle cx="92" cy="178" r="2.5" fill="#D7CCC8" />
            <circle cx="85" cy="170" r="2" fill="#8D6E63" />
          </g>
          
          {/* Seed pods */}
          <ellipse cx="65" cy="105" rx="2" ry="6" transform="rotate(20 65 105)" fill="#8D6E63" opacity="0.22" />
          <ellipse cx="100" cy="115" rx="2" ry="5" transform="rotate(-15 100 115)" fill="#CCA598" opacity="0.2" />
        </svg>
      </motion.div>

      {/* Bottom Right - Complementary autumn - LARGER */}
      <motion.div
        className="fixed bottom-0 right-0 w-48 md:w-72 h-48 md:h-72 pointer-events-none z-10"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.4, delay: 0.6 }}
      >
        <svg viewBox="0 0 180 180" className="w-full h-full" fill="none">
          <path 
            d="M180 180 C150 155, 155 125, 140 95" 
            stroke="#CCA598" 
            strokeWidth="1.1" 
            opacity="0.3"
            strokeLinecap="round"
          />
          <path 
            d="M180 150 C150 135, 140 145, 120 130" 
            stroke="#D7CCC8" 
            strokeWidth="0.7" 
            opacity="0.22"
          />
          
          {/* Autumn leaves */}
          <path d="M145 105 Q138 90, 155 95 Q150 110, 145 105" fill="#D7CCC8" opacity="0.32" />
          <path d="M130 125 Q122 112, 142 118 Q135 130, 130 125" fill="#CCA598" opacity="0.28" />
          <path d="M155 130 Q148 118, 165 122 Q160 135, 155 130" fill="#8D6E63" opacity="0.25" />
          
          {/* Berries */}
          <circle cx="168" cy="160" r="3.5" fill="#5D4037" opacity="0.35" />
          <circle cx="158" cy="170" r="3" fill="#8D6E63" opacity="0.3" />
          <circle cx="172" cy="172" r="2.5" fill="#CCA598" opacity="0.28" />
        </svg>
      </motion.div>

      {/* Floating autumn leaf - left */}
      <motion.div
        className="fixed top-1/4 left-6 md:left-14 w-8 h-8 pointer-events-none"
        animate={{ y: [0, -10, 0], rotate: [0, 15, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      >
        <svg viewBox="0 0 24 24" className="w-full h-full" fill="none">
          <path d="M12 2 Q18 8, 12 22 Q6 8, 12 2" fill="#CCA598" opacity="0.25" />
          <path d="M12 6 L12 18" stroke="#8D6E63" strokeWidth="0.5" opacity="0.3" />
        </svg>
      </motion.div>

      {/* Floating autumn leaf - right */}
      <motion.div
        className="fixed top-1/2 right-6 md:right-14 w-7 h-7 pointer-events-none"
        animate={{ y: [0, -8, 0], rotate: [0, -12, 0] }}
        transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut", delay: 1.5 }}
      >
        <svg viewBox="0 0 20 20" className="w-full h-full" fill="none">
          <path d="M10 2 Q15 7, 10 18 Q5 7, 10 2" fill="#D7CCC8" opacity="0.22" />
        </svg>
      </motion.div>

      {/* Small floating dots */}
      <motion.div
        className="fixed top-1/3 left-16 md:left-28 w-2.5 h-2.5 pointer-events-none"
        animate={{ y: [0, -6, 0], opacity: [0.2, 0.35, 0.2] }}
        transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
      >
        <div className="w-full h-full rounded-full bg-[#CCA598]" />
      </motion.div>

      <motion.div
        className="fixed top-2/3 right-16 md:right-32 w-2 h-2 pointer-events-none"
        animate={{ y: [0, -5, 0], opacity: [0.15, 0.28, 0.15] }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", delay: 2.5 }}
      >
        <div className="w-full h-full rounded-full bg-[#8D6E63]" />
      </motion.div>
    </>
  );
};

export default FloralDecorations;
